import { takeLeading, call, put } from "redux-saga/effects";
import {
    requestUsersAppRoles,
    createSuccessFetchUserAppRoles,
    createFailureFetchUserAppRoles,
    createLogoutAction
} from "./authActions";
import { TResult } from "../../../../sg-core"
import { IContextService } from "../../services/contextService";

const createGetUsersAppRolesSaga = (contextService: IContextService) =>
    function* saga() {
        try {

            // Attempt to initialize with gate token in url.
            const result: TResult<any> = yield call(contextService.getUserAppRoles);
            if (result.isSuccess === true) {

                yield put(createSuccessFetchUserAppRoles(result.value));
                return
            }

            // ...Other initial logging cases here

            yield put(createFailureFetchUserAppRoles(new Error("Failed to get app roles")));


        } catch (e) {
            console.log(e)
            yield put(createLogoutAction());
        }
    };

export default function (contextService: IContextService) {
    return takeLeading(
        requestUsersAppRoles,
        createGetUsersAppRolesSaga(contextService),
    );
}
